import { useMemo, useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { Select, Switch } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { getStaticCities, getStaticProvinces } from "@services/api";
import ComplexSearch from "@/components/coordinate/ComplexSearch";

function Coordinate({ cityId, findCity }) {
  const [searchState, setSearchState] = useState(true);

  const provinceQuery = useQuery(["staticsProvinces"], getStaticProvinces);
  const cityQuery = useQuery(["staticCitys"], getStaticCities);

  const options = useMemo(
    () =>
      cityQuery?.data?.map((city) => {
        const province = provinceQuery?.data?.find(
          (prov) => prov?.id === city?.provinceId
        )?.name;
        return {
          value: city?.id,
          location: city?.location,
          label: province + " " + city?.name,
        };
      }),
    [provinceQuery.data, cityQuery.data]
  );

  const handleChange = (value, option) => {
    findCity(option.location);
  };

  return (
    <div className="flex flex-row justify-center w-full">
      {searchState ? (
        <div>
          <section
            className="flex flex-row justify-center inner-box-hover w-[35vw] max-w-[580px] h-[34px]
            max-lg:flex-col max-lg:gap-3 items-center"
          >
            <Select
              autoComplete="nope"
              suffixIcon={<SearchOutlined />}
              showSearch={true}
              defaultValue={cityId ?? undefined}
              optionFilterProp="label"
              placeholder="جستجو شهر"
              className="lg:w-2/3 max-lg:w-full"
              options={options}
              onChange={handleChange}
            />
            <div className="flex flex-row items-center gap-2 ml-1 max-lg:bg-[#00000062] max-lg:p-1 max-lg:rounded-2xl">
              <p className="text-sm whitespace-nowrap max-lg:text-white">
                جستجو پیشرفته:
              </p>
              <Switch
                onChange={(e) => {
                  setSearchState(e);
                }}
                checked={searchState}
                checkedChildren="غیرفعال"
                unCheckedChildren="فعال"
              />
            </div>
          </section>
        </div>
      ) : (
        <ComplexSearch
          options={options}
          setSearchState={setSearchState}
          findCity={findCity}
          searchState={searchState}
        />
      )}
    </div>
  );
}

export default Coordinate;
